module.exports = __webpack_public_path__ + "static/media/relay_baton.39673b38.webp";